
interface StripePaymentElementProps {
  initError: string | null
  onCancel: () => void
}

export function StripePaymentElement({ initError, onCancel }: StripePaymentElementProps) {
  if (initError) {
    return (
      <div className="text-center space-y-4">
        <p className="text-red-600">Payment system is currently unavailable.</p>
        <button 
          onClick={onCancel} 
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2"
        >
          Close
        </button>
      </div>
    )
  }

  return (
    <div id="payment-element" className="p-4 border rounded-lg bg-white" />
  )
}
